<template>
  <div class="applicat-box">
    <div class="a-tip">
      <div class="at-comtent" v-if="applicant.flowState == 3">
        <div style="white-space: pre-wrap">
          审核不通过原因：{{ applicant.auditReason }}
        </div>
      </div>
      <div class="blacklist-box" v-if="blacklistState && applicantIde">
        <el-icon class="icon-blacklist">
          <CircleCheck />
        </el-icon>
        <p>已通过申请人黑名单校验</p>
      </div>
    </div>
    <div class="applicat">
      <div class="al-title">申请人信息</div>
      <div class="al-basic-info">
        <!-- 申请人类型  -->
        <div class="al-row">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>申请人类型</span>
          </div>
          <el-radio-group
            v-model="applicant.applicantType"
            @change="applicantTypeChange"
          >
            <el-radio-button :label="0">个人/个体工商户</el-radio-button>
            <el-radio-button :label="1">企 业</el-radio-button>
          </el-radio-group>
        </div>
        <!-- 书式类型 -->
        <div class="al-row">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>书式类型</span>
          </div>
          <div class="al-col">
            <div class="al-col-input">
              <el-select
                v-model="applicant.bookType"
                placeholder="请选择"
                style="width: 100%"
                @change="bookTypeChange"
              >
                <el-option
                  v-for="item in bookTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <!-- 主体资格证明文件类型 -->
        <div class="al-row" v-if="applicant.applicantType === 0 && applicant.bookType === 1">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>主体资格证明文件类型</span>
          </div>
          <div class="al-col">
            <div class="al-col-input">
              <el-select
                v-model="applicant.personalSubjectType"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in personalSubjectTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <!-- 证件类型 -->
        <div class="al-row" v-if="applicant.applicantType == 0 || (applicant.applicantType == 1 && applicant.bookType == 1)">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>证件类型</span>
          </div>
          <div class="al-col">
            <div class="al-col-input" v-if="applicant.applicantType == 0">
              <el-select
                v-model="applicant.certificatesType"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in certificatesTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="al-col-input" v-else-if="applicant.applicantType == 1 && applicant.bookType == 1">
              <el-select
                v-model="applicant.certificatesType"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in certificatesTypeListTwo"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <!-- 主体资格证明原文件是否为中文  -->
        <div
          class="al-row"
          v-if="
            applicant.bookType == 3 ||
            applicant.bookType == 4 ||
            applicant.bookType == 5
          "
        >
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>材料是否英文</span>
          </div>
          <el-radio-group v-model="applicant.subjectType">
            <el-radio-button :label="1">中文</el-radio-button>
            <el-radio-button :label="0">英文</el-radio-button>
          </el-radio-group>
        </div>
        <!-- 申请人名称 -->
        <div class="al-row">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>申请人名称</span>
          </div>
          <div class="al-col">
            <div
              class="al-col-autocomplete"
              :class="applicant.bookType == 1 ? '' : 'full'"
            >
              <el-autocomplete
                v-model="applicant.applicantName"
                :fetch-suggestions="queryCompanyList"
                :trigger-on-focus="false"
                @blur="queryBlackList"
                placeholder="请输入"
                @select="handleSelect"
              ></el-autocomplete>
              <el-tooltip
                v-if="applicant.bookType == 1"
                placement="top"
                trigger="hover"
              >
                <template #content
                  >上传{{
                    applicant.applicantType == 0 ? "身份证" : "营业执照"
                  }}自动填写信息</template
                >
                <div class="al-auto-identify" @click="showAutoIdentifyDialog">
                  自动识别
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <!-- 申请人名称（英文） -->
        <div v-if="applicant.bookType != 1" class="al-row">
          <div class="al-row-title">
            <span class="al-row-dage">
              <span v-show="applicant.bookType == 2">*</span>
            </span>
            <span
              >申请人名称<br /><span class="al-row-dage"></span>（英文）</span
            >
          </div>
          <div class="al-col">
            <div class="al-col-input">
              <el-input
                v-model="applicant.applicantEnglishName"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>
        </div>
        <!-- 国家或地区 -->
        <div class="al-row" v-if="applicant.bookType == 2">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>国家或地区</span>
          </div>
          <div class="al-col">
            <div class="al-col-input">
              <el-select
                v-model="applicant.country"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in countryList"
                  :key="index"
                  :label="item.codeSpaceName"
                  :value="item.codeSpaceName"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <!-- 证件号码 -->
        <div class="al-row-warn" v-if="applicant.applicantType == 0">
          <div class="al-row">
            <div class="al-row-title">
              <span class="al-row-dage">*</span>
              <span>证件号码</span>
            </div>
            <div class="al-col">
              <div class="al-col-input">
                <el-input
                  v-model="applicant.idCard"
                  oninput="this.value=this.value.replace(/[^\w]/g,'');"
                  placeholder="请输入"
                  maxlength="30"
                  @blur="queryBlackList"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="al-col-tip" v-if="idCardRepeat">
            <span
              >当前证件号码已创建3个相同主体，请修改或删除历史申请主体。</span
            >
            <span
              style="text-decoration: underline; cursor: pointer"
              @click="goApplicantList(1)"
              >去查看>></span
            >
          </div>
        </div>
        <!-- 统一社会信用代码 -->
        <div class="al-row-warn" v-if="applicant.bookType == 1">
          <div class="al-row">
            <div class="al-row-title">
              <span class="al-row-dage">
                <span
                  v-show="
                    applicant.personalSubjectType === 0 &&
                    applicant.bookType == 1
                  "
                  >*</span
                >
              </span>
              <span
                >统一社会信<br /><span class="al-row-dage"></span>用代码</span
              >
            </div>
            <div class="al-col">
              <div class="al-col-input">
                <el-input
                  v-model="applicant.creditCode"
                  @blur="queryBlackList"
                  oninput="this.value=this.value.replace(/[^\w]/g,'');"
                  placeholder="请输入"
                  maxlength="20"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="al-col-tip" v-if="creditCodeRepeat">
            <span
              >当前信用代码已创建3个相同主体，请修改或删除历史申请主体。</span
            >
            <span
              style="text-decoration: underline; cursor: pointer"
              @click="goApplicantList(2)"
              >去查看>></span
            >
          </div>
        </div>
        <!-- 申请人地址 -->
        <div class="al-row-warn" v-if="applicant.bookType == 1">
          <div class="al-row">
            <div class="al-row-title">
              <span class="al-row-dage">*</span>
              <span>申请人地址</span>
            </div>
            <div class="al-col">
              <div class="al-col-input">
                <el-cascader
                  v-model="addressCodes.addressApplicant"
                  :props="props"
                  :options="millListChildren"
                  :teleported="false"
                  style="width: 100%"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 申请人详细地址 -->
        <div class="al-row-warn">
          <div class="al-row">
            <div class="al-row-title">
              <span class="al-row-dage">*</span>
              <span>申请人详细地址</span>
            </div>
            <div class="al-col">
              <div class="al-col-input">
                <el-input
                  v-model="applicant.applicantAddress"
                  placeholder="请输入"
                  @blur="checkAddress"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="al-col-tip" v-if="showAddressWarn">
            <img
              class="icon-tip"
              src="@/assets/img/common/icon-info-red.png"
              alt=""
            />
            <span>请在地址中填写完整的省市，否则可能导致审核不通过。</span>
          </div>
        </div>
        <!-- 申请人地址（英文） -->
        <div v-if="applicant.bookType != 1" class="al-row">
          <div class="al-row-title">
            <span class="al-row-dage">
              <span v-show="applicant.bookType == 2">*</span>
            </span>
            <span
              >申请人详细地址<span class="al-row-dage"></span>（英文）</span
            >
          </div>
          <div class="al-col">
            <div class="al-col-input">
              <el-input
                v-model="applicant.applicantEnglishAddress"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>
        </div>
        <!-- 申请人邮箱 -->
        <div class="al-row" v-show="false">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>申请人邮箱</span>
          </div>
          <div class="al-col">
            <div class="al-col-input">
              <el-input
                v-model="applicant.domesticReceiverEmail"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>
        </div>
        <!-- 邮政编码 -->
        <div class="al-row">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>邮政编码</span>
          </div>
          <div class="al-col">
            <div class="al-col-input" style="position: relative">
              <el-input
                maxlength="6"
                v-model="applicant.code"
                oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                placeholder="请输入"
                @focus="millStateChange"
                @click.stop="() => {}"
              ></el-input>
              <PostCode
                :millList="millList"
                :millState="millState"
                v-if="millState"
                :alwaysLeft="false"
                :bookType="applicant.bookType"
                :applicantType="applicant.applicantType"
                @codeStateChange="codeStateChange"
                @codeChange="codeChange"
              ></PostCode>
            </div>
          </div>
        </div>
        <!-- 有效期限 -->
        <div class="al-row" v-show="false">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span
              >{{ applicant.applicantType == 1 ? "营业" : "有效" }}期限</span
            >
          </div>
          <div class="al-col">
            <div class="al-col-date">
              <el-date-picker
                v-model="applicant.limitStartTime"
                type="date"
                placeholder="开始日期"
                value-format="YYYY-MM-DD HH:mm:ss"
              ></el-date-picker>
              <span
                v-if="!applicant.limitType"
                style="display: inline-block; padding: 0 6px; line-height: 32px"
                >至</span
              >
              <el-date-picker
                v-if="!applicant.limitType"
                v-model="applicant.limitEndTime"
                type="date"
                placeholder="结束日期"
                value-format="YYYY-MM-DD HH:mm:ss"
              ></el-date-picker>
            </div>
            <div class="al-col-limit">
              <el-checkbox v-model="applicant.limitType">长期</el-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="al-title-line">
        <div class="al-title">材料信息</div>
        <div class="al-title-tip">
          提示：支持上传后OCR智能识别，识别后请核对并修改有误信息
        </div>
      </div>
      <div class="al-file-line">
        <!-- 身份证  -->
        <div
          v-if="applicant.applicantType == 0"
          class="al-row"
          style="align-items: flex-start"
        >
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>身份证</span>
          </div>
          <div class="al-upload">
            <div class="upload-box">
              <el-upload
                v-show="!applicant.applicantIdCardImg"
                ref="applicantIdCardImg"
                :action="applicant.bookType == 1 ? uploadOcr : uploadUrl"
                :on-success="
                  function (response, file) {
                    return handleAvatarSuccessPDF(
                      response,
                      file,
                      'applicantIdCardImg',
                      { type: 0, ocr: applicant.bookType == 1 ? true : false }
                    );
                  }
                "
                :before-upload="beforeAvatarPJUpload"
                :show-file-list="false"
                :limit="1"
                :data="{ type: 2, fileSize: 0, ocrFileType: 0 }"
              >
                <div class="upload-item">
                  <div class="upload-item-no">
                    <el-icon class="icon-size">
                      <Plus />
                    </el-icon>
                    <span>上传文件</span>
                  </div>
                </div>
              </el-upload>
              <div
                class="upload-item upload-hover"
                v-show="applicant.applicantIdCardImg"
              >
                <img class="file-img" :src="fileList.pdf" alt="" />
                <div class="upload-hove-loading">
                  <p @click="onPreview('applicantIdCardImg')">预览</p>
                  <p @click="againUpload('applicantIdCardImg')">重新上传</p>
                  <p @click="onDelete('applicantIdCardImg')">删除</p>
                </div>
              </div>
              <div class="upload-right">
                <div class="upload-by-phone" @click="showUploadQrCode(1)">
                  手机上传
                </div>
                <div class="upload-give" @click="fileView('sfz')">
                  <img class="icon-file" :src="fileList.sfz" alt="" />
                  <img
                    class="icon-give"
                    src="@/assets/img/common/icon-give.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="upload-tip-text">
              <img
                class="icon-tip"
                src="@/assets/img/common/tip-g.png"
                alt=""
              />
              <div class="row-left">2M以内 PDF/JPG</div>
              <div class="row-right">
                {{
                  applicant.applicantType == 1 ? "请盖章后上传" : "请签字后上传"
                }}
              </div>
            </div>
          </div>
        </div>
        <!-- 身份证（英文）  -->
        <div
          v-if="applicant.applicantType == 0 && applicant.subjectType == 0"
          class="al-row"
          style="align-items: flex-start"
        >
          <div class="al-row-title" style="width: auto">
            <span class="al-row-dage">*</span>
            <span>身份证（英文）</span>
          </div>
          <div class="al-upload">
            <div class="upload-box">
              <el-upload
                v-show="!applicant.idCardEnglishPic"
                ref="idCardEnglishPic"
                :action="uploadUrl"
                :on-success="
                  function (response, file) {
                    return handleAvatarSuccessPDF(
                      response,
                      file,
                      'idCardEnglishPic',
                      { type: 0, ocr: false }
                    );
                  }
                "
                :before-upload="beforeAvatarPJUpload"
                :show-file-list="false"
                :limit="1"
                :data="{ type: 2, fileSize: 0 }"
              >
                <div class="upload-item">
                  <div class="upload-item-no">
                    <el-icon class="icon-size">
                      <Plus />
                    </el-icon>
                    <span>上传文件</span>
                  </div>
                </div>
              </el-upload>
              <div
                class="upload-item upload-hover"
                v-show="applicant.idCardEnglishPic"
              >
                <img class="file-img" :src="fileList.pdf" alt="" />
                <div class="upload-hove-loading">
                  <p @click="onPreview('idCardEnglishPic')">预览</p>
                  <p @click="againUpload('idCardEnglishPic')">重新上传</p>
                  <p @click="onDelete('idCardEnglishPic')">删除</p>
                </div>
              </div>
              <div class="upload-right">
                <div class="upload-by-phone" @click="showUploadQrCode(5)">
                  手机上传
                </div>
                <div class="upload-give" @click="fileView('hwsfzm')">
                  <img class="icon-file" :src="fileList.hwsfzm" alt="" />
                  <img
                    class="icon-give"
                    src="@/assets/img/common/icon-give.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="upload-tip-text">
              <img
                class="icon-tip"
                src="@/assets/img/common/tip-g.png"
                alt=""
              />
              <div class="row-left">2M以内 PDF/JPG</div>
              <div class="row-right">
                {{
                  applicant.applicantType == 1 ? "请盖章后上传" : "请签字后上传"
                }}
              </div>
            </div>
          </div>
        </div>
        <!-- 营业执照  -->
        <div v-if="applicant.applicantType == 1 || (applicant.applicantType == 0 && applicant.bookType == 1)" class="al-row" style="align-items: flex-start">
          <div class="al-row-title">
            <span
              class="al-row-dage"
              v-if="
                applicant.applicantType == 1 ||
                applicant.personalSubjectType === 0
              "
              >*</span
            >
            <span>营业执照</span>
          </div>
          <div class="al-upload">
            <div class="upload-box">
              <el-upload
                v-show="!applicant.applicantQualification"
                ref="applicantQualification"
                :action="applicant.bookType == 1 ? uploadOcr : uploadUrl"
                :on-success="
                  function (response, file) {
                    return handleAvatarSuccessPDF(
                      response,
                      file,
                      'applicantQualification',
                      { type: 1, ocr: applicant.bookType == 1 ? true : false }
                    );
                  }
                "
                :before-upload="beforeAvatarPJUpload"
                :show-file-list="false"
                :limit="1"
                :data="{ type: 2, fileSize: 0, ocrFileType: 1 }"
              >
                <div class="upload-item">
                  <div class="upload-item-no">
                    <el-icon class="icon-size">
                      <Plus />
                    </el-icon>
                    <span>上传文件</span>
                  </div>
                </div>
              </el-upload>
              <div
                class="upload-item upload-hover"
                v-show="applicant.applicantQualification"
              >
                <img class="file-img" :src="fileList.pdf" alt="" />
                <div class="upload-hove-loading">
                  <p @click="onPreview('applicantQualification')">预览</p>
                  <p @click="againUpload('applicantQualification')">重新上传</p>
                  <p @click="onDelete('applicantQualification')">删除</p>
                </div>
              </div>
              <div class="upload-right">
                <div class="upload-by-phone" @click="showUploadQrCode(2)">
                  手机上传
                </div>
                <div class="upload-give" @click="fileView('give')">
                  <img
                    class="icon-file"
                    :src="
                      applicant.applicantType == 1
                        ? fileList.give2
                        : fileList.give1
                    "
                    alt=""
                  />
                  <img
                    class="icon-give"
                    src="@/assets/img/common/icon-give.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="upload-tip-text">
              <img
                class="icon-tip"
                src="@/assets/img/common/tip-g.png"
                alt=""
              />
              <div class="row-left">2M以内 PDF/JPG</div>
              <div class="row-right">
                {{
                  applicant.applicantType == 1 ? "请盖章后上传" : "请签字后上传"
                }}
              </div>
            </div>
          </div>
        </div>
        <!-- 营业执照（英文）  -->
        <div
          v-if="applicant.applicantType == 1 && applicant.subjectType == 0"
          class="al-row"
          style="align-items: flex-start"
        >
          <div class="al-row-title" style="width: auto">
            <span class="al-row-dage">*</span>
            <span>营业执照（英文）</span>
          </div>
          <div class="al-upload">
            <div class="upload-box">
              <el-upload
                v-show="!applicant.licenseEnglishPic"
                ref="licenseEnglishPic"
                :action="uploadUrl"
                :on-success="
                  function (response, file) {
                    return handleAvatarSuccessPDF(
                      response,
                      file,
                      'licenseEnglishPic',
                      { type: 1, ocr: false }
                    );
                  }
                "
                :before-upload="beforeAvatarPJUpload"
                :show-file-list="false"
                :limit="1"
                :data="{ type: 2, fileSize: 0 }"
              >
                <div class="upload-item">
                  <div class="upload-item-no">
                    <el-icon class="icon-size">
                      <Plus />
                    </el-icon>
                    <span>上传文件</span>
                  </div>
                </div>
              </el-upload>
              <div
                class="upload-item upload-hover"
                v-show="applicant.licenseEnglishPic"
              >
                <img class="file-img" :src="fileList.pdf" alt="" />
                <div class="upload-hove-loading">
                  <p @click="onPreview('licenseEnglishPic')">预览</p>
                  <p @click="againUpload('licenseEnglishPic')">重新上传</p>
                  <p @click="onDelete('licenseEnglishPic')">删除</p>
                </div>
              </div>
              <div class="upload-right">
                <div class="upload-by-phone" @click="showUploadQrCode(6)">
                  手机上传
                </div>
                <div class="upload-give" @click="fileView('hwgsh')">
                  <img
                    class="icon-file"
                    src="@/assets/img/file/hwgsh.jpg"
                    alt=""
                  />
                  <img
                    class="icon-give"
                    src="@/assets/img/common/icon-give.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="upload-tip-text">
              <img
                class="icon-tip"
                src="@/assets/img/common/tip-g.png"
                alt=""
              />
              <div class="row-left">2M以内 PDF/JPG</div>
              <div class="row-right">
                {{
                  applicant.applicantType == 1 ? "请盖章后上传" : "请签字后上传"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blackliste-errbox" v-if="!blacklistState">
        <el-icon class="icon-blacklist">
          <Warning />
        </el-icon>
        <p>该申请人信息已命中黑名单，请修改后进行保存。</p>
      </div>
      <div class="al-title" style="margin-top: 24px">委托书信息</div>
      <!-- 委托书模版  -->
      <div class="al-proxy">
        <div class="al-row" style="align-items: flex-start">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>委托书模版：</span>
          </div>
          <div class="al-upload" style="margin-top: 0px">
            <div class="upload-tip" style="min-height: 34px">
              <img
                style="cursor: pointer"
                class="icon-tip"
                src="@/assets/img/common/icon-upload.png"
                alt=""
                @click="downloadPowerAttorney"
              />
              <span style="cursor: pointer" @click="downloadPowerAttorney"
                >下载盖章文件及图例</span
              >
            </div>
            <div class="upload-box">
              <el-upload
                v-show="!applicant.applicantProxy"
                ref="applicantProxy"
                :action="uploadUrl"
                :on-success="
                  function (response, file) {
                    return handleAvatarSuccessPDF(
                      response,
                      file,
                      'applicantProxy',
                      { type: '', ocr: false }
                    );
                  }
                "
                :before-upload="beforeAvatarPJUpload"
                :show-file-list="false"
                :limit="1"
                :data="{ type: 9, fileSize: 0 }"
              >
                <div class="upload-item">
                  <div class="upload-item-no">
                    <el-icon class="icon-size">
                      <Plus />
                    </el-icon>
                    <span>上传文件</span>
                  </div>
                </div>
              </el-upload>
              <div
                class="upload-item upload-hover"
                v-if="applicant.applicantProxy"
              >
                <img
                  class="file-img"
                  :src="
                    applicant.applicantProxy.indexOf('http://') > -1 ||
                    applicant.applicantProxy.indexOf('https://') > -1
                      ? applicant.applicantProxy
                      : fileUrl + applicant.applicantProxy
                  "
                  alt=""
                />
                <div class="upload-hove-loading">
                  <p @click="onPreview('applicantProxy')">预览</p>
                  <p @click="againUpload('applicantProxy')">重新上传</p>
                  <p @click="onDelete('applicantProxy')">删除</p>
                </div>
              </div>
              <div class="upload-right">
                <div class="upload-by-phone" @click="showUploadQrCode(3)">
                  手机上传
                </div>
                <div class="upload-give" @click="fileView('wts')">
                  <img
                    class="icon-file"
                    :src="
                      applicant.applicantType == 1
                        ? fileList.wts2
                        : fileList.wts1
                    "
                    alt=""
                  />
                  <img
                    class="icon-give"
                    src="@/assets/img/common/icon-give.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="al-proxy-right">
            <div class="al-row-title" style="min-height: 34px; width: auto">
              <span class="al-row-dage">*</span>
              <span>委托书模版生成结果：</span>
            </div>
            <div class="al-upload" style="margin-top: 10px; margin-left: 90px">
              <div class="upload-box">
                <div
                  class="upload-item upload-hover"
                  v-if="applicant.simpleUrl"
                >
                  <img
                    class="file-img"
                    :src="
                      applicant.simpleUrl.indexOf('http://') > -1 ||
                      applicant.simpleUrl.indexOf('https://') > -1
                        ? applicant.simpleUrl
                        : fileUrl + applicant.simpleUrl
                    "
                    alt=""
                  />
                  <div class="upload-hove-loading">
                    <p @click="onPreview('simpleUrl')">预览</p>
                  </div>
                </div>
                <div class="upload-item" v-else>
                  <div class="upload-item-no">
                    <el-icon class="icon-size">
                      <Plus />
                    </el-icon>
                    <span>上传文件</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="upload-type-size">
          <div style="padding-bottom: 4px">上传要求：</div>
          <div>
            1、上传委托书模板只需在右下角{{
              applicant.applicantType == 1 ? "盖章" : "签字"
            }}；
          </div>
          <div>2、请确保上传委托书模板图片分辨率在600*600-4000*4000之间；</div>
          <div>3、请确保上传委托书模板图片大小不能超过2MB的JPG格式图片；</div>
          <div>
            4、请确保上传委托书模板信息定位点（页面左上角、右上角、左下角三个黑色小方块）完整且清晰；<br />纸面工整顺平，不能有褶皱、反光等;
          </div>
        </div>
      </div>
      <!-- 委托书模版复用法律声明  -->
      <div class="al-row1" style="align-items: flex-start">
        <div class="al-row-title">
          <span class="al-row-dage">*</span>
          <span>委托书模版复用法律声明：</span>
        </div>
        <div class="al-upload">
          <div class="upload-tip"></div>
          <div class="upload-box">
            <el-upload
              v-show="!applicant.applicantProxyStatement"
              ref="applicantProxyStatement"
              :action="uploadUrl"
              :on-success="
                function (response, file) {
                  return handleAvatarSuccessPDF(
                    response,
                    file,
                    'applicantProxyStatement',
                    { type: '', ocr: false }
                  );
                }
              "
              :before-upload="beforeAvatarPJUpload"
              :show-file-list="false"
              :limit="1"
              :data="{ type: 9, fileSize: 0 }"
            >
              <div class="upload-item">
                <div class="upload-item-no">
                  <el-icon class="icon-size">
                    <Plus />
                  </el-icon>
                  <span>上传文件</span>
                </div>
              </div>
            </el-upload>
            <div
              class="upload-item upload-hover"
              v-if="applicant.applicantProxyStatement"
            >
              <img class="file-img" :src="fileList.pdf" alt="" />
              <div class="upload-hove-loading">
                <p @click="onPreview('applicantProxyStatement')">预览</p>
                <p @click="againUpload('applicantProxyStatement')">重新上传</p>
                <p @click="onDelete('applicantProxyStatement')">删除</p>
              </div>
            </div>
            <div class="upload-right">
              <div class="upload-by-phone" @click="showUploadQrCode(4)">
                手机上传
              </div>
              <div class="upload-give" @click="fileView('wtsCopy')">
                <img
                  class="icon-file"
                  :src="
                    applicant.applicantType == 1 ? fileList.sm2 : fileList.sm1
                  "
                  alt=""
                />
                <img
                  class="icon-give"
                  src="@/assets/img/common/icon-give.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="upload-tip-text" style="padding-left: 88px">
            <img class="icon-tip" src="@/assets/img/common/tip-g.png" alt="" />
            <div class="row-left">2M以内 PDF/JPG</div>
            <div class="row-right">
              {{
                applicant.applicantType == 1 ? "请盖章后上传" : "请签字后上传"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="qr-box" v-if="showQrBox">
      <div class="qr-title">
        <span>微信扫码上传</span>
        <el-icon
          color="#FFFFFF"
          @click="showQrBox = false"
          style="
            cursor: pointer;
            padding: 5px;
            margin-left: 113px;
            margin-top: 15px;
            opacity: 0.5;
          "
          size="14px"
          ><CloseBold
        /></el-icon>
      </div>
      <div class="qr-img">
        <img src="@/assets/img/common/image-qr-bg.png" alt="" />
        <img :src="qrImageData" alt="" />
      </div>
      <!-- <div class="qr-url">
        <span>{{ miniProgramUrl }}</span>
        <img src="@/assets/img/common/icon-copy.png" alt="" @click="copy(miniProgramUrl)">
      </div> -->
      <span class="qr-tip">{{ expireDate }}失效</span>
    </div>
    <el-dialog
      v-model="autoIdentifyDialog"
      width="720px"
      style="
        height: 540px;
        margin-top: calc(15vh + 100px);
        padding: 0;
        border-radius: 8px;
      "
      :show-close="false"
    >
      <template #header="{ close }">
        <div class="my-header">
          <div class="my-header-title">识别助手</div>
          <div style="flex: 1"></div>
          <el-icon
            color="#9EA0A5"
            @click="close"
            style="cursor: pointer; padding: 5px"
            ><Close
          /></el-icon>
        </div>
      </template>
      <div class="custom-dialog-box">
        <div class="auto-identify-content">
          <div class="auto-identify-img">
            <span class="auto-identify-title">文件识别区域</span>
            <div class="auto-identify-img-upload">
              <el-upload
                class="auto-identify-upload-box"
                ref="applicantIdCardOcr"
                drag
                :action="uploadOcr"
                :on-success="
                  function (response, file) {
                    return handleAvatarSuccessPDF(
                      response,
                      file,
                      'applicantIdCardOcr',
                      {
                        type: applicant.applicantType == 0 ? 0 : 1,
                        ocr: true,
                      }
                    );
                  }
                "
                :before-upload="beforeAvatarPJUpload"
                :show-file-list="false"
                :limit="1"
                :data="{
                  type: 2,
                  fileSize: 0,
                  ocrFileType: applicant.applicantType == 0 ? 0 : 1,
                }"
              >
                <img src="@/assets/img/common/icon-ocr-file.png" alt="" />
              </el-upload>
              <span>点击上传，或将文件拖拽进该区域</span>
              <span>支持JPG/PNG文件</span>
            </div>
          </div>
          <div class="auto-identify-info">
            <span class="auto-identify-title">信息确认区域</span>
            <div class="auto-identify-info-edit-line">
              <span>申请人名称</span>
              <el-input
                v-model="ocrApplicantInfo.applicantName"
                placeholder="自动识别填入后可手动编辑"
              ></el-input>
            </div>
            <div class="auto-identify-info-edit-line">
              <span>证件号码</span>
              <el-input
                v-model="ocrApplicantInfo.creditCode"
                placeholder="自动识别填入后可手动编辑"
              ></el-input>
            </div>
            <div class="auto-identify-info-edit-line">
              <span>申请人地址</span>
              <el-input
                v-model="ocrApplicantInfo.applicantAddress"
                placeholder="自动识别填入后可手动编辑"
                :rows="2"
                type="textarea"
              ></el-input>
            </div>
            <span
              class="auto-identify-title"
              style="margin-top: 10px"
              v-if="!applicant.applicantType == 0"
              >工商识别信息</span
            >
            <div
              class="auto-identify-info-business-line"
              v-if="!applicant.applicantType == 0"
            >
              <span>申请人名称：</span>
              <span>{{ ocrBusinessInfo.applicantName }}</span>
            </div>
            <div
              class="auto-identify-info-business-line"
              v-if="applicant.bookType == 1"
            >
              <span>信用代码：</span>
              <span>{{
                ocrBusinessInfo.creditCode ? ocrBusinessInfo.creditCode : "-"
              }}</span>
              <div
                @click="
                  ocrApplicantInfo.creditCode = ocrBusinessInfo.creditCode
                    ? ocrBusinessInfo.creditCode
                    : ocrApplicantInfo.creditCode
                "
              >
                添加
              </div>
            </div>
            <div
              class="auto-identify-info-business-line"
              v-if="!applicant.applicantType == 0"
            >
              <span>申请人地址：</span>
              <span>{{
                ocrBusinessInfo.applicantAddress
                  ? ocrBusinessInfo.applicantAddress
                  : "-"
              }}</span>
              <div
                @click="
                  ocrApplicantInfo.applicantAddress =
                    ocrBusinessInfo.applicantAddress
                      ? ocrBusinessInfo.applicantAddress
                      : ocrApplicantInfo.applicantAddress
                "
              >
                添加
              </div>
            </div>
          </div>
        </div>
        <div class="custom-dialog-footer">
          <div @click="autoIdentifyDialog = false">取消</div>
          <div @click="saveAutoIdentifyInfo">保存</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { ElLoading } from "element-plus";
import _validate from "@/framework/common/qds_validate";
import _tools from "@/components/common/tools";
import {
  downloadPowerAttorney,
  queryBrandRegisterCountryList,
  recogniseInfoV3,
  genWtsJpgV2,
  queryCompanyInfo,
  queryCompanyByKeyword,
  generateCode,
  getFile,
  checkRepeat,
} from "@/server/applicant";
import PostCode from "./postCode.vue";
export default {
  props: ["applicant", "blacklistState", "millList", "millListChildren", "addressCodes"],
  components: {
    PostCode: PostCode,
  },
  data() {
    return {
      uploadUrl: `https://phoenix.quandashi.com/upload/upload`,
      uploadOcr: "https://phoenix.quandashi.com/upload/uploadWithOcr",
      applicantIde: "",
      bookTypeList: [
        { label: "中国大陆", value: 1 },
        { label: "海外", value: 2 },
        { label: "中国台湾", value: 3 },
        { label: "中国香港", value: 4 },
        { label: "中国澳门", value: 5 },
      ],
      certificatesTypeList: [
        { label: "身份证", value: 1 },
        { label: "护照", value: 2 },
        { label: "其他", value: 3 },
      ],
      certificatesTypeListTwo: [
        { label: "营业执照", value: 4 },
        { label: "事业单位法人证书", value: 5 },
        { label: "社会团体法人登记证书", value: 6 },
        { label: "民办非企业单位登记证书", value: 7 },
        { label: "基金会法人登记证书", value: 8 },
        { label: "律师事务所执业许可证", value: 9 },
        { label: "其他", value: 3 },
      ],
      personalSubjectTypeList: [
        { label: "个体工商户营业执照", value: 1 },
        { label: "农村土地承包经营合同复印件", value: 2 },
        { label: "其他", value: 3 },
      ],
      countryList: [],
      fileList: {
        sfz: require("../../../assets/img/files/sfz.jpg"),
        give1: require("../../../assets/img/files/give1.jpg"),
        give2: require("../../../assets/img/files/give2.jpg"),
        sm1: require("../../../assets/img/files/sm1.jpg"),
        sm2: require("../../../assets/img/files/sm2.jpg"),
        wts1: require("../../../assets/img/files/wts1.jpg"),
        wts2: require("../../../assets/img/files/wts1.jpg"),
        hwsfzm: require("../../../assets/img/file/hwsfzm.jpg"),
        give: require("../../../assets/img/file/give2.png"),
        hwgsh: require("../../../assets/img/file/hwgsh.jpg"),
        wts: require("../../../assets/img/file/wts.png"),
        wtsCopy: require("../../../assets/img/file/wts-copy.png"),
        pdf: require("../../../assets/img/file/icon-pdf.png"),
      },
      loadingInstance: null,
      cascderState: true,
      millState: false,
      showAddressWarn: false,
      startTime: "",
      endTime: "",
      fileUrl: this.$imgBaseUrl,
      autoIdentifyDialog: false,
      showQrBox: false,
      qrImageData: "",
      uniqueId: "",
      expireDate: "",
      qrUploadFileType: 1,
      ocrApplicantInfo: {
        applicantName: "",
        creditCode: "",
        applicantAddress: "",
      },
      ocrBusinessInfo: {
        applicantName: "",
        creditCode: "",
        applicantAddress: "",
      },
      companyList: [],
      creditCodeRepeat: false,
      idCardRepeat: false,
      miniProgramUrl: "",
      props: {
        label: "name",
        value: "id",
        children: "children",
      },
    };
  },

  mounted() {},

  methods: {
    // 初始化数据
    init() {
      this.queryBrandRegisterCountryList();
      this.checkAddress();
      this.showAddressWarn = false;
      this.showQrBox = false;
      this.autoIdentifyDialog = false;
      this.creaditCodeRepeat = false;
      this.idCardRepeat = false;
    },
    // 获取国家或地区
    async queryBrandRegisterCountryList() {
      let res = await queryBrandRegisterCountryList({});
      this.countryList = res.list;
    },
    checkAddress() {
      if (this.applicant.applicantAddress) {
        if (
          this.applicant.bookType == 1 &&
          !_validate.checkMill(this.applicant.applicantAddress)
        ) {
          this.showAddressWarn = true;
        } else if (
          this.applicant.bookType == 3 &&
          this.applicant.applicantAddress.indexOf("台湾") < 0
        ) {
          this.showAddressWarn = true;
        } else if (
          this.applicant.bookType == 4 &&
          this.applicant.applicantAddress.indexOf("香港") < 0
        ) {
          this.showAddressWarn = true;
        } else if (
          this.applicant.bookType == 5 &&
          this.applicant.applicantAddress.indexOf("澳门") < 0
        ) {
          this.showAddressWarn = true;
        } else {
          this.showAddressWarn = false;
        }
      } else {
        this.showAddressWarn = false;
      }
    },
    // 申请人类型监测
    applicantTypeChange() {
      this.changecertificatesType();
    },
    // 主体资格类型监测
    subjectTypeChange(val) {
      this.applicant.subjectType = val;
    },
    // 修改资质文件类型
    changecertificatesType() {
      if (this.applicant.bookType == 2) {
        this.applicant.certificatesType = 3;
      }
      if (this.applicant.applicantType == 1) {
        this.applicant.certificatesType = 4;
      } else {
        this.applicant.certificatesType = 1;
      }
    },
    // 时间监测
    dateChange(val) {
      console.log(val);
      console.log(this.applicant.limitStartTime);
      console.log(this.applicant.limitEndTime);
    },
    // 书式类型监测
    bookTypeChange(val) {
      let self = this;
      if (val == 2) {
        self.applicant.subjectType = 0;
      } else {
        self.applicant.subjectType = 1;
      }
      self.changecertificatesType();
    },
    // 邮政编码监测
    cascaderChange() {
      setTimeout(() => {
        this.$refs.cascader.$children[0].$refs.input.click();
      }, 300);
    },
    // 上传限制PDF JPG PNG 2
    beforeAvatarPJ(file) {
      let isPDF = "";
      if (
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "application/pdf"
      ) {
        isPDF = file.type;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      return new Promise((resolve, reject) => {
        if (!isPDF) {
          this.$message.error("上传文件只能是 PNG或JPG、PDF 格式!");
          reject();
        } else if (!isLt2M) {
          this.$message.error("上传文件大小不能超过 2MB!");
          reject();
        } else {
          this.loadingInstance = ElLoading.service({
            text: "上传中...",
          });
          resolve();
        }
      });
    },
    // 上传限制PDF JPG 2
    beforeAvatarPJUpload(file) {
      console.log(file);
      let isPDF = "";
      if (file.type == "image/jpeg" || file.type == "application/pdf") {
        isPDF = file.type;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      return new Promise((resolve, reject) => {
        if (!isPDF) {
          this.$message.error("上传文件只能是 PDF或JPG 格式!");
          reject();
        } else if (!isLt2M) {
          this.$message.error("上传文件大小不能超过 2MB!");
          reject();
        } else {
          this.loadingInstance = ElLoading.service({
            text: "上传中...",
          });
          resolve();
        }
      });
    },
    // 上传限制JPG
    beforeAvatarJpgUpload(file) {
      let isJPG = "";
      if (file.type == "image/jpeg") {
        isJPG = file.type;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      return new Promise((resolve, reject) => {
        if (!isJPG) {
          this.$message.error("上传文件只能是 JPG 格式!");
          reject();
        } else if (!isLt2M) {
          this.$message.error("上传文件大小不能超过 2MB!");
          reject();
        } else {
          this.loadingInstance = ElLoading.service({
            text: "上传中...",
          });
          resolve();
        }
      });
    },
    // 上传成功回调PDF
    handleAvatarSuccessPDF(res, file, name, obj) {
      let self = this;
      self.loadingInstance.close();
      if (res.code == 9091 && res.subCode == 10002) {
        if (obj.ocr) {
          if (!_validate.checkListEmpty(res.data.url.urls)) {
            if (name == "applicantIdCardOcr") {
              self.$refs[name].clearFiles();
              if (obj.type == 0) {
                self.ocrApplicantInfo.applicantName =
                  res.data.ocr.words_result["姓名"].words;
                self.ocrApplicantInfo.applicantAddress =
                  res.data.ocr.words_result["住址"].words;
                self.ocrApplicantInfo.creditCode =
                  res.data.ocr.words_result["公民身份号码"].words;
              } else {
                self.ocrApplicantInfo.applicantName =
                  res.data.ocr.words_result["单位名称"].words;
                self.ocrApplicantInfo.applicantAddress =
                  res.data.ocr.words_result["地址"].words;
                self.ocrApplicantInfo.creditCode =
                  res.data.ocr.words_result["社会信用代码"].words;
                if (self.ocrApplicantInfo.applicantName) {
                  self.getOcrBusinessInfo(self.ocrApplicantInfo.applicantName);
                }
              }
              return;
            }
            self.applicant[name] = res.data.url.urls[0];
            if (obj.type == 0) {
              if (!_validate.checkEmpty(res.data.ocr)) {
                if (
                  _validate.checkEmpty(self.applicant.applicantName) &&
                  !_validate.checkEmpty(res.data.ocr.words_result["姓名"])
                ) {
                  self.applicant.applicantName =
                    res.data.ocr.words_result["姓名"].words;
                }
                if (
                  _validate.checkEmpty(self.applicant.applicantAddress) &&
                  !_validate.checkEmpty(res.data.ocr.words_result["住址"])
                ) {
                  self.applicant.applicantAddress =
                    res.data.ocr.words_result["住址"].words;
                }
                self.checkAddress();
                if (
                  _validate.checkEmpty(self.applicant.idCard) &&
                  !_validate.checkEmpty(
                    res.data.ocr.words_result["公民身份号码"]
                  )
                ) {
                  self.applicant.idCard =
                    res.data.ocr.words_result["公民身份号码"].words;
                }
                if (
                  _validate.checkEmpty(self.applicant.limitStartTime) &&
                  !_validate.checkEmpty(
                    res.data.ocr.words_result["签发日期"]
                  ) &&
                  !_validate.checkEmpty(
                    res.data.ocr.words_result["签发日期"].words
                  ) &&
                  !_validate.checkNYR2(
                    res.data.ocr.words_result["签发日期"].words
                  )
                ) {
                  let year = res.data.ocr.words_result["签发日期"].words
                    .toString()
                    .slice(0, 4);
                  let mounth = res.data.ocr.words_result["签发日期"].words
                    .toString()
                    .slice(4, 6);
                  let date = res.data.ocr.words_result["签发日期"].words
                    .toString()
                    .slice(6, 8);
                  self.applicant.limitStartTime =
                    year + "-" + mounth + "-" + date + " 00:00:00";
                }
                if (
                  _validate.checkEmpty(self.applicant.limitEndTime) &&
                  !_validate.checkEmpty(
                    res.data.ocr.words_result["失效日期"]
                  ) &&
                  !_validate.checkEmpty(
                    res.data.ocr.words_result["失效日期"].words
                  ) &&
                  !_validate.checkNYR2(
                    res.data.ocr.words_result["失效日期"].words
                  )
                ) {
                  let year = res.data.ocr.words_result["失效日期"].words
                    .toString()
                    .slice(0, 4);
                  let mounth = res.data.ocr.words_result["失效日期"].words
                    .toString()
                    .slice(4, 6);
                  let date = res.data.ocr.words_result["失效日期"].words
                    .toString()
                    .slice(6, 8);
                  self.applicant.limitEndTime =
                    year + "-" + mounth + "-" + date + " 23:59:59";
                }
              }
            } else if (obj.type == 1) {
              if (!_validate.checkEmpty(res.data.ocr)) {
                if (
                  _validate.checkEmpty(self.applicant.applicantName) &&
                  !_validate.checkEmpty(res.data.ocr.words_result["单位名称"])
                ) {
                  self.applicant.applicantName =
                    res.data.ocr.words_result["单位名称"].words;
                }
                if (
                  _validate.checkEmpty(self.applicant.applicantAddress) &&
                  !_validate.checkEmpty(res.data.ocr.words_result["地址"])
                ) {
                  self.applicant.applicantAddress =
                    res.data.ocr.words_result["地址"].words;
                }
                if (
                  _validate.checkEmpty(self.applicant.creditCode) &&
                  !_validate.checkEmpty(
                    res.data.ocr.words_result["社会信用代码"]
                  ) &&
                  res.data.ocr.words_result["社会信用代码"].words != "无"
                ) {
                  self.applicant.creditCode =
                    res.data.ocr.words_result["社会信用代码"].words;
                  if (
                    self.applicant.applicantType == 0 &&
                    self.applicant.idCard == ""
                  ) {
                    self.applicant.idCard = self.applicant.creditCode;
                  }
                }
                if (
                  _validate.checkEmpty(self.applicant.limitStartTime) &&
                  !_validate.checkEmpty(
                    res.data.ocr.words_result["成立日期"]
                  ) &&
                  res.data.ocr.words_result["成立日期"].words != "无" &&
                  !_validate.checkNYR(
                    res.data.ocr.words_result["成立日期"].words
                  )
                ) {
                  self.applicant.limitStartTime =
                    res.data.ocr.words_result["成立日期"].words
                      .replace("年", "-")
                      .replace("月", "-")
                      .replace("日", "") + " 00:00:00";
                  self.applicant.limitType = true;
                }
                self.checkAddress();
                // if (_validate.checkEmpty(self.applicant.limitEndTime) && res.data.ocr.words_result['有效期'].words != '无' && res.data.ocr.words_result['有效期'].words != '年月日') {
                //   if (res.data.ocr.words_result['有效期'].words == '不约定期限' && res.data.ocr.words_result['有效期起始日期'].words != '无' && res.data.ocr.words_result['有效期起始日期'].words != '年月日') {
                //     self.applicant.limitEndTime = res.data.ocr.words_result['有效期起始日期'].words.replace('年', '-').replace('月', '-').replace('日', '') + ' 00:00:00'
                //   } else {
                //     self.applicant.limitEndTime = res.data.ocr.words_result['有效期'].words.replace('年', '-').replace('月', '-').replace('日', '') + ' 23:59:59'
                //   }
                // }
              }
            }
          }
        } else {
          if (!_validate.checkListEmpty(res.data.urls)) {
            self.applicant[name] = res.data.urls[0];
          }
        }
        if (name == "applicantProxy") {
          self.genWtsJpgV2(res.data.urls[0]);
        }
      } else {
        self.$message.warning(res.subMessage);
      }
      self.$refs[name].clearFiles();
    },
    // 身份证/营业执照OCR识别
    async recogniseInfoV3(url, type) {
      let self = this;
      let params = {
        fileUrl:
          url.indexOf("http://") > -1 || url.indexOf("https://") > -1
            ? url
            : this.$imgBaseUrl + url,
        type: type,
      };
      let res = await recogniseInfoV3(params);
      if (type == 0) {
        if (
          _validate.checkEmpty(self.applicant.applicantName) &&
          !_validate.checkEmpty(res.words_result["姓名"])
        ) {
          self.applicant.applicantName = res.words_result["姓名"].words;
        }
        if (
          _validate.checkEmpty(self.applicant.applicantAddress) &&
          !_validate.checkEmpty(res.words_result["住址"])
        ) {
          self.applicant.applicantAddress = res.words_result["住址"].words;
        }
        if (
          _validate.checkEmpty(self.applicant.idCard) &&
          !_validate.checkEmpty(res.words_result["公民身份号码"])
        ) {
          self.applicant.idCard = res.words_result["公民身份号码"].words;
        }
        if (
          _validate.checkEmpty(self.applicant.limitStartTime) &&
          _validate.checkEmpty(res.words_result["签发日期"]) &&
          _validate.checkEmpty(res.words_result["签发日期"].words)
        ) {
          let year = res.words_result["签发日期"].words.toString().slice(0, 4);
          let mounth = res.words_result["签发日期"].words
            .toString()
            .slice(4, 6);
          let date = res.words_result["签发日期"].words.toString().slice(6, 8);
          self.applicant.limitStartTime =
            year + "-" + mounth + "-" + date + " 00:00:00";
        }
        if (
          _validate.checkEmpty(self.applicant.limitEndTime) &&
          _validate.checkEmpty(res.words_result["失效日期"]) &&
          _validate.checkEmpty(res.words_result["失效日期"].words)
        ) {
          let year = res.words_result["失效日期"].words.toString().slice(0, 4);
          let mounth = res.words_result["失效日期"].words
            .toString()
            .slice(4, 6);
          let date = res.words_result["失效日期"].words.toString().slice(6, 8);
          self.applicant.limitEndTime =
            year + "-" + mounth + "-" + date + " 23:59:59";
        }
      } else if (type == 1) {
        if (
          _validate.checkEmpty(self.applicant.applicantName) &&
          _validate.checkEmpty(res.words_result["单位名称"])
        ) {
          self.applicant.applicantName = res.words_result["单位名称"].words;
        }
        if (
          _validate.checkEmpty(self.applicant.applicantAddress) &&
          _validate.checkEmpty(res.words_result["地址"])
        ) {
          self.applicant.applicantAddress = res.words_result["地址"].words;
        }
        if (
          _validate.checkEmpty(self.applicant.creditCode) &&
          _validate.checkEmpty(res.words_result["社会信用代码"])
        ) {
          self.applicant.creditCode = res.words_result["社会信用代码"].words;
        }
        if (
          _validate.checkEmpty(self.applicant.limitStartTime) &&
          _validate.checkEmpty(res.words_result["成立日期"]) &&
          res.words_result["成立日期"].words != "无"
        ) {
          self.applicant.limitStartTime =
            res.words_result["成立日期"].words
              .replace("年", "-")
              .words.replace("月", "-")
              .words.replace("日", "-") + " 00:00:00";
          self.applicant.limitType = 1;
        }
        // if (_validate.checkEmpty(self.applicant.limitEndTime) && res.words_result['有效期'].words != '无') {
        //   if (res.words_result['有效期'].words == '不约定期限') {
        //     self.applicant.limitEndTime = res.words_result['有效期起始日期'].words.replace('年', '-').words.replace('月', '-').words.replace('日', '-') + ' 00:00:00'
        //   } else {
        //     self.applicant.limitEndTime = res.words_result['有效期'].words.replace('年', '-').words.replace('月', '-').words.replace('日', '-') + ' 23:59:59'
        //   }
        // }
        if (
          this.applicant.applicantType == 0 &&
          this.applicant.bookType == 1 &&
          this.applicant.idCard == ""
        ) {
          this.applicant.idCard = this.applicant.creditCode;
        }
      }
    },
    // 获取ocr工商信息
    async getOcrBusinessInfo(companyName) {
      this.ocrBusinessInfo.applicantName = companyName;
      let res = await queryCompanyInfo({ companyName: companyName });
      console.log(res);
      this.ocrBusinessInfo.applicantName = res.name ? res.name : companyName;
      this.ocrBusinessInfo.applicantAddress = res.address ? res.address : "";
      this.ocrBusinessInfo.creditCode = res.creditNo ? res.creditNo : "";
    },
    // 委托书生成盖章
    async genWtsJpgV2(url) {
      let self = this;
      let params = {
        originalFileURL:
          url.indexOf("http://") > -1 || url.indexOf("https://") > -1
            ? url
            : this.$imgBaseUrl + url,
        address: self.applicant.applicantAddress,
      };
      let res = await genWtsJpgV2(params);
      if (!_validate.checkListEmpty(res)) {
        res.forEach((item) => {
          if (item.type == 1) {
            self.applicant.simpleUrl = item.url;
          } else if (item.type == 2) {
            self.applicant.applicantProxyChapter = item.url;
          } else if (item.type == 3) {
            self.applicant.tickLocation = item.url;
          }
        });
      }
    },
    // 预览
    onPreview(name) {
      let self = this;
      if (!_validate.checkEmpty(name)) {
        let url =
          self.applicant[name].indexOf("http://") > -1 ||
          self.applicant[name].indexOf("https://") > -1
            ? self.applicant[name]
            : self.$imgBaseUrl + self.applicant[name];
        window.open(url, "_blank");
      } else {
        self.$message.warning("预览链接有误，请稍后刷新重试！");
      }
    },
    // 删除
    onDelete(name) {
      let self = this;
      self.applicant[name] = "";
    },
    // 重新上传
    againUpload(name) {
      console.log(name);
      let self = this;
      self.$refs[name].$el.querySelector("input").click();
    },
    // 查看文件示例
    fileView(img) {
      window.open(this.fileList[img]);
    },
    // 下载生成委托书模板
    async downloadPowerAttorney() {
      let self = this;
      if (_validate.checkEmpty(self.applicant.applicantName)) {
        self.$message.warning("请输入申请人名称");
        return;
      }
      // if (self.applicant.applicantType === 0 && self.applicant.applicantDetailType === 0 && _validate.checkEmpty(self.applicant.idCard)) {
      //   self.$message.warning("请输入证件号码")
      //   return
      // }
      if (_validate.checkEmpty(self.applicant.applicantAddress)) {
        self.$message.warning("请输入申请人地址");
        return;
      }
      if (
        self.applicant.bookType == 2 &&
        _validate.checkEmpty(self.applicant.country)
      ) {
        self.$message.warning("请选择国家或地区");
        return;
      }
      self.checkAddress();
      if (self.showAddressWarn) {
        self.$message.warning("请在申请人地址中填写完整的省市");
        return;
      }
      if (_validate.checkEmpty(self.applicant.code)) {
        self.$message.warning("请输入邮政编码");
        return;
      }
      let params = {
        applicantName:
          self.applicant.applicantType === 0
            ? self.applicant.applicantName + self.applicant.idCard
            : self.applicant.applicantName,
        address: self.applicant.applicantAddress,
        country:
          self.applicant.bookType == 1
            ? "中国"
            : self.applicant.bookType == 3
            ? "中国台湾"
            : self.applicant.bookType == 4
            ? "中国香港"
            : self.applicant.bookType == 5
            ? "中国澳门"
            : self.applicant.bookType == 2
            ? self.applicant.country
            : "",
        code: self.applicant.code,
        isClient: 2,
        pageType: 2,
      };
      let res = await downloadPowerAttorney(params);
      window.open(
        res.docUrl.indexOf("http://") > -1 ||
          res.docUrl.indexOf("https://") > -1
          ? res.docUrl
          : this.$imgBaseUrl + res.docUrl
      );
    },
    // 黑名单校验
    queryBlackList() {
      this.$emit("getQueryBlackList");
      this.doCheckRepeat();
    },
    // 统一社会信用代码输入监测
    creditCodeChange() {
      if (
        this.applicant.applicantType == 0 &&
        this.applicant.bookType == 1 &&
        this.applicant.idCard == ""
      ) {
        this.applicant.idCard = this.applicant.creditCode;
      }
    },
    // 监测传参不及时更新
    changeDate() {
      this.$forceUpdate();
    },
    // 邮政编码监测
    codeChange(val) {
      this.applicant.code = val;
      this.millState = false;
    },
    // 邮编是否显示控制
    codeStateChange(state) {
      this.millState = state;
    },
    millStateChange() {
      let self = this;
      setTimeout(() => {
        self.millState = true;
      }, 300);
    },
    showAutoIdentifyDialog() {
      this.ocrApplicantInfo = {
        applicantName: "",
        creditCode: "",
        applicantAddress: "",
      };
      this.ocrBusinessInfo = {
        applicantName: "",
        creditCode: "",
        applicantAddress: "",
      };
      this.autoIdentifyDialog = true;
    },
    saveAutoIdentifyInfo() {
      this.applicant.applicantName = this.ocrApplicantInfo.applicantName
        ? this.ocrApplicantInfo.applicantName
        : this.applicant.applicantName;
      if (this.applicant.applicantType != 0) {
        this.applicant.creditCode = this.ocrApplicantInfo.creditCode
          ? this.ocrApplicantInfo.creditCode
          : this.applicant.creditCode;
      } else {
        this.applicant.idCard = this.ocrApplicantInfo.creditCode
          ? this.ocrApplicantInfo.creditCode
          : this.applicant.idCard;
      }
      this.applicant.applicantAddress = this.ocrApplicantInfo.applicantAddress
        ? this.ocrApplicantInfo.applicantAddress
        : this.applicant.applicantAddress;
      this.autoIdentifyDialog = false;
    },
    showUploadQrCode(fileType) {
      this.getQrCode(fileType);
    },
    async queryCompanyList(queryString, cb) {
      let data = {
        keyword: this.applicant.applicantName,
        withData: 1,
        start: 0,
        size: 10,
      };
      let res = await queryCompanyByKeyword(data);
      this.companyList = res;
      var names = [];
      names = this.companyList.map((item) => {
        return {
          value: item.name,
          creditNo: item.creditNo,
          address: item.address,
          postCode: item.postCode,
        };
      });
      cb(names);
    },
    handleSelect(item) {
      this.applicant.applicantAddress = item.address;
      this.applicant.code = item.postCode;
      this.applicant.creditCode = item.creditNo;
    },
    // 生成二维码
    async getQrCode(fileType) {
      let data = {
        applicantId: this.applicant.applicantId,
        applicantType: this.applicant.applicantType,
        fileType: fileType,
      };
      let res = await generateCode(data);
      if (res) {
        this.qrImageData = "data:image/jpeg;base64," + res.file;
        this.uniqueId = res.uniqueId;
        if (this.uniqueId) {
          this.expireDate =
            res.expireDate.substring(0, 4) +
            "年" +
            res.expireDate.substring(4, 6) +
            "月" +
            res.expireDate.substring(6, 8) +
            "日";
          this.qrUploadFileType = fileType;
          this.showQrBox = true;
          this.miniProgramUrl =
            "weixin://dl/business/?appid=wx54b358b257c9aae6&path=pages/welcome/welcome&query=scene%3D" +
            this.uniqueId +
            "&env_version=trial";
          setTimeout(() => {
            this.getFile();
          }, 5000);
        }
      }
    },
    // 获取手机上传文件
    async getFile() {
      let res = await getFile({ uniqueId: this.uniqueId });
      if (!res && this.showQrBox) {
        setTimeout(() => {
          this.getFile();
        }, 5000);
      } else if (res) {
        switch (this.qrUploadFileType) {
          case 1:
            this.applicant.applicantIdCardImg = res;
            break;
          case 2:
            this.applicant.applicantQualification = res;
            break;
          case 3:
            this.applicant.applicantProxy = res;
            this.genWtsJpgV2(res);
            break;
          case 4:
            this.applicant.applicantProxyStatement = res;
            break;
          case 5:
            this.applicant.idCardEnglishPic = res;
            break;
          case 6:
            this.applicant.licenseEnglishPic = res;
            break;
          default:
            break;
        }
        this.showQrBox = false;
      }
    },
    // 判断同一主体申请主体是否超过三个
    doCheckRepeat() {
      if (this.applicant.applicantType == 0) {
        // 两个号码都需要判断时
        this.checkRepeat(this.applicant.creditCode, true, false);
        this.checkRepeat(this.applicant.idCard, true, true);
      } else if (this.applicant.applicantType != 0) {
        this.checkRepeat(this.applicant.creditCode, false, false);
      } else {
        this.checkRepeat(this.applicant.idCard, false, true);
      }
    },
    async checkRepeat(creditCode, multiCheck, isIdCard) {
      var res = 0;
      if (creditCode) {
        res = await checkRepeat({
          creditCode: creditCode,
          applicantIde: this.applicant.applicantIde,
        });
      }
      if (res && res >= 3) {
        if (isIdCard) {
          this.idCardRepeat = true;
        } else {
          this.creaditCodeRepeat = true;
        }
      } else {
        if (isIdCard) {
          this.idCardRepeat = false;
        } else {
          this.creaditCodeRepeat = false;
        }
      }
    },
    goApplicantList(type) {
      var url = "";
      if (type == 1) {
        url = url + "/applicant?applicantName=" + this.applicant.idCard;
      } else {
        url = url + "/applicant?applicantName=" + this.applicant.creditCode;
      }
      window.open(url, "_blank");
    },
    copy(text) {
      this.$copyText(text).then((e) => {
        this.$message.success("复制成功");
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
<style lang="less" scoped>
&:deep(.el-drawer__body) {
  padding: 0;
}

&:deep(.el-icon-arrow-up) {
  line-height: 32px;
}

&:deep(.el-input__suffix) {
  display: flex;
  align-items: center;
}

&:deep(.el-range-separator) {
  line-height: 26px;
}

&:deep(.el-radio-group) {
  width: 280px;
}

&:deep(.el-radio-button) {
  width: 140px;
  --el-color-primary: #ffc18e;
}

&:deep(.el-radio-button__inner) {
  width: 140px;
}

&:deep(.el-radio-button.is-active) {
  .el-radio-button__inner {
    color: #ff7200;
    background: #ff72001a;
    border-color: #ffc18e;
  }
}

.my-header {
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  padding: 14px 15px 14px 20px;
  box-shadow: 0px 0px 4px 0px rgba(12, 27, 50, 0.1);

  .my-header-title {
    color: #111111;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    letter-spacing: 2px;
  }
}
</style>
